import http from '../../../Utils/http';
import responseMessageHandler from '../../../Utils/ResponseMessageHandler';

const getDsoRevenue = {
  name: 'getDsoRevenue',
  state: {
    loading: false,
    error: '',
    cost: 0,
    monthlyRevenue: [],
  },
  reducers: {
    getRequested(state) {
      return {
        ...state,
        loading: true,
        error: '',
        cost: 0,
        monthlyRevenue: [],
      };
    },

    getReceived(state, payload) {
      return {
        ...state,
        loading: false,
        error: '',
        cost: payload.cost || 0,
        monthlyRevenue: payload.monthlyRevenue || [],
      };
    },

    getRequestFailed(state, payload) {
      return {
        ...state,
        loading: false,
        error: payload,
        cost: 0,
        monthlyRevenue: [],
      };
    },
  },
  effects: (dispatch) => ({
    async fetchDsoRevenue() {
      try {
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        const orgId = userInfo?.org_id;
        const url = `savvy/organization/campaign-dso-revenue/${orgId}`;
        
        this.getRequested();

        const response = await http.get(url);
        
        if (response && response?.data) {
          const data = response.data.data;
          
          let monthlyRevenue = [];
          if (data.monthlyRevenue && Array.isArray(data.monthlyRevenue)) {
            monthlyRevenue = data.monthlyRevenue.map(revenue => 
              parseFloat(revenue || 0).toFixed(2)
            );
          } else {
            const currentCost = parseFloat(data.cost || 0).toFixed(2);
            monthlyRevenue = [0, 0, 0, 0, 0, currentCost];
          }
          
          this.getReceived({
            cost: parseFloat(data.cost || 0).toFixed(2),
            monthlyRevenue: monthlyRevenue,
          });
        }
      } catch (err) {
        this.getRequestFailed(err.message);
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: responseMessageHandler.show(err.message),
            show: true,
          },
        });
      }
    },
  }),
};

export default getDsoRevenue;
